import { render, staticRenderFns } from "./InstituitionStaffList.vue?vue&type=template&id=503eaf70"
import script from "./InstituitionStaffList.vue?vue&type=script&lang=js"
export * from "./InstituitionStaffList.vue?vue&type=script&lang=js"
import style0 from "./InstituitionStaffList.vue?vue&type=style&index=0&id=503eaf70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports